/** A seat's account may carry no name yet, and then the email is all there is to show */
export function teamMemberName(member: { name?: string | null; email: string }): string {
  return member.name?.trim() || member.email;
}
